module.exports = __webpack_public_path__ + "img/Octocat-spidertocat.74150617.png";